export default {
	title: 'safety',
	icon: 'far fa-shield',
	components: [
		{ title: 'max_power_protection', component: 'max_power_protection_roller' },
		{ title: 'obstacle_detection', component: 'obstacle_detection' },
		{ title: 'safety_switch', component: 'safety_switch' },
	],
};
